// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import EmploymentTypesTable from "../../DataTables/MasterData/EmploymentTypes/EmploymentTypesTable";

// Modals
import CreateEmpTypeModal from "../../UiKits/Modal/MasterData/EmploymentTypes/CreateEmploymentTypes";

const EmpTypesContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Employment Types" parent="Master Data" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Master Data Management</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage employment types options used throughout the HRIS for
                  employee and applicant personal information.
                </P>
                <CreateEmpTypeModal />
                <EmploymentTypesTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EmpTypesContainer;
